// src/modules/app-views/_apps/appmulti/leads/pages/Init/components/tableColumns/destinyColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import dayjs from 'dayjs';
import { FaPlaneArrival, FaPlaneDeparture } from 'react-icons/fa';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// Destiny + departure/arrival dates from quotations[0] (most-recent, sorted desc by BE)
// *******************************************************************************
function destinyColumn(buildColumnProps) {
  return {
    key: 'destiny',
    title: translateX('destiny'),
    dataIndex: 'destiny',
    ...buildColumnProps('destiny'),
    align: 'left',
    width: 220,
    render: (_, record) => {
      const q = record?.customData?.quotations?.[0];
      if (!q) return '—';
      return (
        <div className="line-height-md">
          <div>{translateX(q.destiny)}</div>
          <div className="text-muted font-size-sm">
            <FaPlaneDeparture className="mr-1" />
            {q.departure ? dayjs(q.departure).format('DD/MM/YYYY') : '—'}
            <FaPlaneArrival className="ml-2 mr-1" />
            {q.arrival ? dayjs(q.arrival).format('DD/MM/YYYY') : '—'}
          </div>
        </div>
      );
    },
  };
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default destinyColumn;
